/**
 * Channels page component.
 */
import Channel from '@shared/classes/channel';
import TChannelList from '../templates/channelList';
import { channelsSelector } from '../../../shared/store/slices/channels.slice';
import { eventsSelector } from '../../../shared/store/slices/events.slice';
import { routerSelector } from '@shared/store/slices/router.slice';
import { useAppSelector } from '../../../shared/store/hooks';
import { useMemo } from 'react';

/**
 * Displays a channels list.
 */
export default function ChannelsPage() {
  const { currentEvents } = useAppSelector(eventsSelector);
  const { favouriteChannels } = useAppSelector(channelsSelector);
  const {
    params: { current: currentParams },
  } = useAppSelector(routerSelector);

  const currentIndex = useMemo(() => {
    return currentParams?.channel && favouriteChannels?.length
      ? Math.max(
          favouriteChannels?.findIndex(
            (item) => item.id === (currentParams.channel as Channel).id
          ),
          0
        )
      : 0;
  }, [currentParams, favouriteChannels]);

  return (
    <>
      {favouriteChannels?.length && (
        <TChannelList
          channelsData={favouriteChannels}
          currentChannel={favouriteChannels[currentIndex]}
          currentEvents={currentEvents}
          currentIndex={currentIndex}
          focusOnEnter={(currentParams?.stacked as boolean) ?? false}
        />
      )}
    </>
  );
}
